// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/assets/img/website/acc-minus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/assets/img/website/acc-plus.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .topHeader {
  background: linear-gradient(90deg,
  color-mix(in srgb, var(--primary-color) 60%, transparent) 0%,
  color-mix(in srgb, var(--secondary-color) 60%, transparent) 100%);
height: 530px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 100px;
}

.topHeader h1 {
  font-size: 60px;
  font-weight: 700;
  font-family: var(--font-codec-cold);
  line-height: 60px;
  color: var(--text-primary);
}

.topHeader p {
  font-size: 20px;
  font-weight: 500;
  color: var(--bg-black);
  text-align: center; 
  margin: 20px auto 0 auto;
  line-height: 25px;
  max-width: 1050px;
} */

.faqs-content {
  /* padding-top: 100px; */
  padding-bottom: 50px;
}

.faqs-container {
  max-width: 850px;
  margin: 0 auto;
}

.faqs-content .title {
  font-size: var(--font-size-xxxlarge);
  font-weight: var(--font-bold);
  color: var(--text-primary);
  font-family: var(--font-codec-cold);
  line-height: 45px;
  text-align: center;
  margin-bottom: 60px;
  margin-top: 80px;
}

/* .custom-accordion .accordion-item {
  border: none;
  margin-bottom: 20px;
  border-radius: 20px;
  overflow: hidden;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  background: linear-gradient(86deg, #6318C6 0%, #F2CC00 100%);
  padding: 2px;
}

.custom-accordion .accordion-item .accordion-content-wrapper {
  background: white;
  border-radius: 18px;
  overflow: hidden;
} */
.accordion-item {
  border: none;
  background-color: transparent;
  margin-bottom: 30px;
}

.accordion-header {
  border: none;
  margin-bottom: 20px;
  border-radius: 20px;
  overflow: hidden;
  background: white;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
  position: relative;
  background: linear-gradient(90deg, #6318C6 0%, #F2CC00 100%);
  padding: 2px;
}

.accordion-button,
.accordion-button:not(.collapsed) {
  font-size: var(--font-size-25);
  font-weight: var(--font-medium);
  line-height: 32px;
  padding: 20px 41px;
  color: var(--text-black-light-5);
  border-radius: 19px !important;
  transition: all 0.5s ease-in-out;
  position: relative;
}

.accordion-button:hover {
  transform: translateY(-1px);
  box-shadow: 4px 4px 15px rgba(0, 0, 0, 0.1);
}

.accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  transform: none;
  background-size: 25px;
  background-position: center;
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  margin-right: 10px;
  margin-left: auto;
  transition: all 0.3s ease-in-out;
}

.accordion-button.collapsed::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 25px;
  background-position: center;
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  margin-right: 10px;
  margin-left: auto;
  transition: all 0.3s ease-in-out;
}

.accordion-collapse {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.accordion-collapse.collapse {
  height: 0;
  opacity: 0;
  transform: translateY(-10px);
}

.accordion-collapse.collapse.show {
  height: auto;
  opacity: 1;
  transform: translateY(0);
}

.accordion-body {
  font-size: var(--font-size-25);
  font-weight: var(--font-medium);
  line-height: 40px;
  color: var(--text-black-light-5);
  padding: 20px 0 0 0;
  animation: fadeInUp 0.4s ease-out;
}

.accordion-button:not(.collapsed) {
  background-color: white;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {

  /* .topHeader{
    height: 400px;
 
  }
  .topHeader h1{
    font-size: 30px;
    line-height: 35px;
    margin-top: 20px;
  }
  .topHeader p{
    font-size: 16px;
    line-height: 20px;
    } */
  .faqs-content .title {
    font-size: var(--font-size-regular) !important;
    margin-bottom: 30px;
    margin-top: 40px;
  }

  .accordion-button.collapsed::after, .accordion-button:not(.collapsed)::after {
    width: 14px;
    height: 14px;
  }

  .accordion-button,
  .accordion-button:not(.collapsed) {
    font-size: var(--font-size-xsmall);
    padding: 10px 9px 10px 20px;
  }

  .faqs-container .accordion-body {
    font-size: var(--font-size-small);
  }

  .accordion-button, .accordion-button:not(.collapsed) {
    line-height: 25px;
    /* text-indent: -25px; */
  }

  .faqs-container .accordion-body ul li{
    font-size: var(--font-size-small);
    line-height: 1.5;
  }


  .accordion-body {
    font-size: var(--font-size-18);
    line-height: 25px;
    padding-top: 0;
  }

  .faqs-container {
    max-width: 90%;
  }

  .accordion-button:hover {
    transform: translateY(0px);
    box-shadow: none;
  }
}

@media (min-width: 1025px) and (max-width: 1280px) {
  .faqs-content .title {
    font-size: var(--font-size-40)!important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Website/FAQsPage/FAQsPage.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4BG;;AAEH;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;GAgBG;AACH;EACE,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,kBAAkB;EAClB,4DAA4D;EAC5D,YAAY;AACd;;AAEA;;EAEE,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,yDAA4E;EAC5E,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,yDAA2E;EAC3E,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE;;;;;;;;;;;;OAYK;EACL;IACE,8CAA8C;IAC9C,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;EAClB;;;EAGA;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF","sourcesContent":["/* .topHeader {\n  background: linear-gradient(90deg,\n  color-mix(in srgb, var(--primary-color) 60%, transparent) 0%,\n  color-mix(in srgb, var(--secondary-color) 60%, transparent) 100%);\nheight: 530px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding-top: 100px;\n}\n\n.topHeader h1 {\n  font-size: 60px;\n  font-weight: 700;\n  font-family: var(--font-codec-cold);\n  line-height: 60px;\n  color: var(--text-primary);\n}\n\n.topHeader p {\n  font-size: 20px;\n  font-weight: 500;\n  color: var(--bg-black);\n  text-align: center; \n  margin: 20px auto 0 auto;\n  line-height: 25px;\n  max-width: 1050px;\n} */\n\n.faqs-content {\n  /* padding-top: 100px; */\n  padding-bottom: 50px;\n}\n\n.faqs-container {\n  max-width: 850px;\n  margin: 0 auto;\n}\n\n.faqs-content .title {\n  font-size: var(--font-size-xxxlarge);\n  font-weight: var(--font-bold);\n  color: var(--text-primary);\n  font-family: var(--font-codec-cold);\n  line-height: 45px;\n  text-align: center;\n  margin-bottom: 60px;\n  margin-top: 80px;\n}\n\n/* .custom-accordion .accordion-item {\n  border: none;\n  margin-bottom: 20px;\n  border-radius: 20px;\n  overflow: hidden;\n  background: white;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  position: relative;\n  background: linear-gradient(86deg, #6318C6 0%, #F2CC00 100%);\n  padding: 2px;\n}\n\n.custom-accordion .accordion-item .accordion-content-wrapper {\n  background: white;\n  border-radius: 18px;\n  overflow: hidden;\n} */\n.accordion-item {\n  border: none;\n  background-color: transparent;\n  margin-bottom: 30px;\n}\n\n.accordion-header {\n  border: none;\n  margin-bottom: 20px;\n  border-radius: 20px;\n  overflow: hidden;\n  background: white;\n  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */\n  position: relative;\n  background: linear-gradient(90deg, #6318C6 0%, #F2CC00 100%);\n  padding: 2px;\n}\n\n.accordion-button,\n.accordion-button:not(.collapsed) {\n  font-size: var(--font-size-25);\n  font-weight: var(--font-medium);\n  line-height: 32px;\n  padding: 20px 41px;\n  color: var(--text-black-light-5);\n  border-radius: 19px !important;\n  transition: all 0.5s ease-in-out;\n  position: relative;\n}\n\n.accordion-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 4px 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.accordion-button:not(.collapsed)::after {\n  background-image: url('../../../../public/assets/img/website/acc-minus.svg');\n  transform: none;\n  background-size: 25px;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 25px;\n  height: 25px;\n  margin-right: 10px;\n  margin-left: auto;\n  transition: all 0.3s ease-in-out;\n}\n\n.accordion-button.collapsed::after {\n  background-image: url('../../../../public/assets/img/website/acc-plus.svg');\n  background-size: 25px;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 25px;\n  height: 25px;\n  margin-right: 10px;\n  margin-left: auto;\n  transition: all 0.3s ease-in-out;\n}\n\n.accordion-collapse {\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n}\n\n.accordion-collapse.collapse {\n  height: 0;\n  opacity: 0;\n  transform: translateY(-10px);\n}\n\n.accordion-collapse.collapse.show {\n  height: auto;\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.accordion-body {\n  font-size: var(--font-size-25);\n  font-weight: var(--font-medium);\n  line-height: 40px;\n  color: var(--text-black-light-5);\n  padding: 20px 0 0 0;\n  animation: fadeInUp 0.4s ease-out;\n}\n\n.accordion-button:not(.collapsed) {\n  background-color: white;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 768px) {\n\n  /* .topHeader{\n    height: 400px;\n \n  }\n  .topHeader h1{\n    font-size: 30px;\n    line-height: 35px;\n    margin-top: 20px;\n  }\n  .topHeader p{\n    font-size: 16px;\n    line-height: 20px;\n    } */\n  .faqs-content .title {\n    font-size: var(--font-size-regular) !important;\n    margin-bottom: 30px;\n    margin-top: 40px;\n  }\n\n  .accordion-button.collapsed::after, .accordion-button:not(.collapsed)::after {\n    width: 14px;\n    height: 14px;\n  }\n\n  .accordion-button,\n  .accordion-button:not(.collapsed) {\n    font-size: var(--font-size-xsmall);\n    padding: 10px 9px 10px 20px;\n  }\n\n  .faqs-container .accordion-body {\n    font-size: var(--font-size-small);\n  }\n\n  .accordion-button, .accordion-button:not(.collapsed) {\n    line-height: 25px;\n    /* text-indent: -25px; */\n  }\n\n  .faqs-container .accordion-body ul li{\n    font-size: var(--font-size-small);\n    line-height: 1.5;\n  }\n\n\n  .accordion-body {\n    font-size: var(--font-size-18);\n    line-height: 25px;\n    padding-top: 0;\n  }\n\n  .faqs-container {\n    max-width: 90%;\n  }\n\n  .accordion-button:hover {\n    transform: translateY(0px);\n    box-shadow: none;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1280px) {\n  .faqs-content .title {\n    font-size: var(--font-size-40)!important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
